const UrlName = '/train/v1/train'
export default API => ({
    getCourseId({data, params}) {
        return API({ url: `${UrlName}/findIndexTrain`, params, data });
    },
    getExamId({data, params}) {
        return API({ url: `${UrlName}/findExamTrain`, params, data });
    }
})